<template>
  <div class="col-sm-12">
    <br />
    <br />
    <h3>Database Columns</h3>
    <div>
      <div>
        <div>
          <div>
            <p class="NOTE">
              Both the MS Access database and Excel file have identical column names. The matrix below Exlpains the various columns and ther
              definitions.
            </p>
            <p class="caution">NOTE: Do not change the column names. If you do so, your uploaded transactions will fail.</p>
            <br />
          </div>
        </div>
        <div>
          <span>
            <br />

            <div>
              <div class="container">
                <div>
                  <span class="mednote">
                    Username<br />
                    <div class="">(required)</div>
                  </span>
                  <span class="def">
                    If this is an update, the username <em>must</em> contain a valid username that matches the password for the location name or
                    location ID listed. <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; If this is a brand new user (not an update) remember that the
                    username, password and location must be unique. If it is not unique, you will overwrite an existing user.
                  </span>
                </div>
                <div>
                  <span class="mednote">
                    New_Username<br />
                    <div class="">(updates only)</div>
                  </span>
                  <span class="def">
                    If you wish to change the username of a person, you must put the <em>NEW</em> username here. See
                    <a class="text" href="index.cfm?action=admin.helpHandler&amp;help=changePassword">Changing a Username</a> for help on using the
                    new Username field.
                  </span>
                </div>
                <div>
                  <span class="mednote">
                    Password<br />
                    <div class="">(required)</div>
                  </span>
                  <span class="def">
                    If you are doing an update this field must match (along with the username and location) the value stored in the database. To
                    change the password, do <em>not</em> change this field. Instead, put the new password in the <em>new_password</em> field.
                    <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;If this is a brand new user (not an update) remember that the username, password
                    and location must be unique. If it is not unique, you will overwrite an existing user.
                  </span>
                </div>
                <div>
                  <span class="mednote">
                    New_Password<br />
                    <div class="">(updates only)</div>
                  </span>
                  <span class="def">
                    If this is an update and not a new user, and you wish to change a particular users password. Simply put the new password in this
                    field and make sure the <em>username</em>, <em>password</em>, and either the company name or company id field match the user you
                    are trying to update. See
                    <a class="text" href="index.cfm?action=admin.helpHandler&amp;help=changePassword">Changing a users password</a> for help on using
                    the new password field. <br />
                    &nbsp;&nbsp;&nbsp;&nbsp;<span class="Caution"
                      >Note: Putting a value in this field will have no affect if the record is an insert. A password must be at least 5 characters
                      long.</span
                    >
                  </span>
                </div>
                <div>
                  <span class="mednote">
                    Points<br />
                    <div class="">(Optional - number)<br />( default=0)</div>
                  </span>
                  <span class="def">
                    If you are doing an <em>UPDATE</em>, the number in this field is <em>ADDED</em> to the value the user already has. It does not
                    <em><strong>REPLACE</strong></em> the number of points that the user has, it <em><strong>ADDS</strong></em> to them. For example,
                    if you have a user with 100 points and you put 110 points in the upload file, the user will have <em>210</em> points, not
                    <em>110</em> points. <br />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; If this is a brand new user, the value in this field represents the initial
                    points awarded to the user. To <em><strong>subtract</strong></em>
                    points from a user, simply put in a negative number. The transaction report will list "points subtracted".
                  </span>
                </div>
                <div>
                  <span class="mednote">
                    SingleItem<br />
                    <div class="">(Optional - 1 or 0)<br />( default=0)</div>
                  </span>
                  <span class="def">
                    If (per your agreement with incentiweb), your users may only order a single item from the catalog, then you
                    <strong><em>must</em></strong> place a 1 in this column. This is usually termed an <em>award program</em>. If you have questions
                    regarding this column, leave it as a zero (0) and contact incentiweb sales support.
                  </span>
                </div>
                <div>
                  <span class="mednote">
                    Administrator<br />
                    <div class="">(Optional - 1 or 0)<br />( default=0)</div>
                  </span>
                  <span class="def">
                    If you wish for a user to be an administrator and manage users and award points, put a <strong>1</strong> in this column. If it is
                    zero or blank the user will have access to the store(s) and be able to order, but they will not have access to any administrative
                    functions.<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span class="Caution">
                      Note: The client will be able to administer whichever company or location you have chosen for him in the company_name or
                      company_id field. Use <em>user manager</em> to authorize him or her for more companies or locations.
                    </span>
                  </span>
                </div>
                <div>
                  <span class="mednote">
                    Disabled<br />
                    <div class="">(Optional - 1 or 0)<br />( default=0)</div>
                  </span>
                  <span class="def">
                    If you wish to <em><strong>lock out </strong></em> a user or make them inactive, set this column to 1. The user will still remain
                    in the database, but they will not have access to stores or ordering.
                  </span>
                </div>
                <div>
                  <span class="mednote">
                    Code<br />
                    <div class="">(Optional)</div>
                  </span>
                  <span class="def">
                    This is a field for internal use. It serves as a way of grouping users together. It is most often used as a department field. For
                    example, you might set it to <em>sales</em>, <em>management</em>, and <em>Service</em>. The transaction report can them group
                    transaction according to the codes you have created. <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span class="Caution"> Note: this field is most often planned in advance with the help of Incentiweb sales.</span>
                  </span>
                </div>
                <div>
                  <span class="mednote">
                    Program Name<br />
                    <div class="">(Optional)</div>
                  </span>
                  <span class="def">
                    If you are participating in a program you can use this field to get added points assigned correctly to the appropriate program.
                    See <a class="text" href="index.cfm?action=admin.helpHandler&amp;help=Programs">Programs</a> for assistance in finding the
                    programs to which your company is assigned. You may use either the program name or the program id (see next column definition).
                    Remember, if you use the program name it must be exact. For example <em>Let's grow together</em> and
                    <em>Lets grow together</em> are not the same thing (notice the apostrophe). The program_id is a more accurate way of assigning a
                    program.
                  </span>
                </div>
                <div>
                  <span class="mednote">
                    Program ID<br />
                    <div class="">(Optional)</div>
                  </span>
                  <span class="def">
                    If you are participating in a program you can use this field to get added points assigned correctly to the appropriate program.
                    See <a class="text" href="index.cfm?action=admin.helpHandler&amp;help=Programs">Programs</a>
                    for assistance in finding the programs to which your company is assigned. You may use either the program name or the program id
                    (see column definition above).
                  </span>
                </div>
                <div>
                  <span class="mednote">
                    SSN<br />
                    <div class="">(Optional)</div>
                  </span>
                  <span class="def">Social Security Number of the user.</span>
                </div>
                <div>
                  <span class="mednote">
                    FirstName<br />
                    <div class="">(Required)</div>
                  </span>
                  <span class="def">User's first name</span>
                </div>
                <div>
                  <span class="mednote">
                    LastName<br />
                    <div class="">(Required)</div>
                  </span>
                  <span class="def">User's Last Name</span>
                </div>
                <div>
                  <span class="mednote">
                    MiddleInitial<br />
                    <div class="">(Optional)</div>
                  </span>
                  <span class="def">User's middle initial</span>
                </div>
                <div>
                  <span class="mednote">
                    Address1<br />
                    <div class="">(Optional)</div>
                  </span>
                  <span class="def">First Address line (street name and number)</span>
                </div>
                <div>
                  <span class="mednote">
                    Address2<br />
                    <div class="">(Optional)</div>
                  </span>
                  <span class="def">Second Address line (suite or apartment number)</span>
                </div>
                <div>
                  <span class="mednote">
                    City<br />
                    <div class="">(Optional)</div>
                  </span>
                  <span class="def">City of residence</span>
                </div>

                <div>
                  <span class="mednote">
                    State<br />
                    <div class="">(Optional)</div>
                  </span>
                  <span class="def">State of Residence</span>
                </div>

                <div>
                  <span class="mednote">
                    Zip<br />
                    <div class="">(Optional)</div>
                  </span>
                  <span class="def">Zip Code or postal code.</span>
                </div>
                <div>
                  <span class="mednote">
                    DayPhone<br />
                    <div class="">(Optional)</div>
                  </span>
                  <span class="def">Phone number for contact during the day.</span>
                </div>
                <div>
                  <span class="mednote">
                    EveningPhone<br />
                    <div class="">(Optional)</div>
                  </span>
                  <span class="def">Phone number for contact in the evening.</span>
                </div>
                <div>
                  <span class="mednote">
                    Email<br />
                    <div class="">(Optional)</div>
                  </span>
                  <span class="def">Valid Email Address</span>
                </div>
                <div>
                  <span class="mednote">
                    Email_msg<br />
                    <div class="">(Optional)</div>
                  </span>
                  <span class="def">
                    <em>If </em>you have entered a valid email address and <em>if</em> you have entered something in both this field and the
                    <em>email_subject</em> field (see below), then the update or insert action when finalized will also generate an email to the email
                    address specified. The email will contain the subject from email_subject and the body from email_msg. <br />
                    <br />
                    NOTE: If you are adding points for a program consider using the global email options. See
                    <a class="text" href="index.cfm?action=admin.helpHandler&amp;help=email">Notifying your users</a>
                    for more information.
                  </span>
                </div>
                <div>
                  <span class="mednote">
                    Email_subject<br />
                    <div class="">(Optional)</div>
                  </span>
                  <span class="def">
                    <em>If </em>you have entered a valid email address and <em>if</em> you have entered something in both this field and the
                    <em>email_msg</em> field (see above), then the update or insert action when finalized will also generate an email to the email
                    address specified. The email will contain the subject from email_subject and the body from email_msg. <br />
                    <br />
                    NOTE: If you are adding points for a program consider using the global email options. See
                    <a class="text" href="index.cfm?action=admin.helpHandler&amp;help=email">Notifying your users</a>
                    for more information.
                  </span>
                </div>
                <div>
                  <span class="mednote">
                    Transaction_Comments<br />
                    <div class="">(Optional)</div>
                  </span>
                  <span class="def">
                    These are placed in the "comments" field for the transaction. This is useful if you are adding or subtracting points. You can
                    specify the reason for the addition (or subtraction).
                  </span>
                </div>
              </div>
            </div>
            <br />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Column',
};
</script>
<style lang="scss" scoped>
.container {
  border: 0px solid transparent;
  font-size: 14px;
  width: inherit;
  display: flex;
  flex-direction: column;
  & > div {
    display: flex;
    text-align: left;
    margin-bottom: 0.5%;
    & > span {
      flex-basis: 40%;
    }
    & > span:first-child {
      flex-basis: 20%;
    }
  }
}
fieldset {
  padding: 0.35em 0.625em 0.75em;
  margin: 0 5px;
  border: 1px solid silver;
  border-radius: 8px;
}
legend {
  width: auto;
  padding: 10px;
  font-size: 15px;
  color: #333;
  border: 0;
  border-bottom: none;
}
</style>
